import React, {useEffect} from "react";
import {useHistory, useLocation} from "react-router";
import {View} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";

import Auth from "shared/Auth/auth";
import useAuth from "shared/Auth/hooks/useAuth";
import {rootURL} from "shared/Utils/WhereAmI";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {pageNames, sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";

import {RegisterPage1Heading} from "../components/RegisterPage1Heading";
import {RegisterPage1Content} from "../components/RegisterPage1Content";
import {AuthPageContainer} from "../components/AuthPageContainer";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_REGISTER} from "../../../../translations/signup";
import {CookieSettings} from "../../../../widgets/shared/components/CookieSettings/CookieSettings";

export function RegisterPage1({primaryApp}: {primaryApp: string}) {
    const {authState} = useAuth();
    const {t} = useTranslation(IntlNamespaces.SIGNUP);
    const history = useHistory();
    const location = useLocation();
    const redirectUrl = `${rootURL(location.pathname)}/buddies`;
    const {trackEvent} = useAnalytics();

    useEffect(() => {
        if (Auth.loggedIn(authState)) {
            return history.replace(redirectUrl);
        }
        trackEvent(sharedEvents.pageViewed.name, {
            prefix: pageNames.prospectSignUpStageOne,
        });

        // Empty deps as replicating componentDidMount behaviour.
        // We can only fire this once, as we know authState will
        // change when we complete Register Page 1, but we do not
        // want to redirect to /buddies after the form is submitted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <View alignItems="center" gap="small">
            <AuthPageContainer>
                <PageTitle title={t(INTL_REGISTER.key, INTL_REGISTER.defaultValue)} />
                <RegisterPage1Heading />
                <RegisterPage1Content primaryApp={primaryApp} />
            </AuthPageContainer>
            <CookieSettings />
        </View>
    );
}
